module.exports = __webpack_public_path__ + "media/images/categories/flats-e9ce9ba4ab1d4e312f611062be062487.png";